import { React, useState } from "react";
import { useSelector } from "react-redux";
import EcardIntro from "./EcardIntro";
import EcardAnimation from "./EcardAnimation";

function EcardPreview() {
  const currentRequest = useSelector(
    (state) => state.configurator.ConfiguratorRequest
  );

  const [showAnimation, setShowAnimation] = useState(false);

  function showAnimationClickHandler() {
    setShowAnimation(true);
  }

  return (
    <div>
      {!showAnimation && <EcardIntro onClickHandler={showAnimationClickHandler} />}
      {showAnimation && <EcardAnimation />}
    </div>
  );
}

export default EcardPreview;
